
export const SERVICE_AREA_LATLNG = {
    'Guelph': {latLng:[43.5448048, -80.24816659999999],radius:20},
    'Thunder Bay': {latLng:[48.3808951, -89.2476823],radius:45},
    'Waterloo': {latLng:[43.4642578, -80.5204096],radius:20},
    'Cambridge': {latLng:[43.3616211, -80.3144276],radius:20},
    // 'Georgetown':{latLng:[43.6502,-79.9036],radius:5},
  }
